import { jsx as _jsx } from "react/jsx-runtime";
import { TimelineDot as MuiTimelineDot } from '@mui/lab';
import { Icon } from '../../legacy/components';
import { styled } from '../../legacy/utils';
export function TimelineDot({ iconVariant = 'check-2-solid', iconColor, }) {
    return (_jsx(TimelineDotStyled, { iconColor: iconColor, children: _jsx(Icon, { fontSize: "small", variant: iconVariant }) }));
}
const TimelineDotStyled = styled(MuiTimelineDot, {
    shouldForwardProp: (prop) => prop !== 'iconColor',
})(({ theme, iconColor }) => ({
    '&.MuiTimelineDot-root': {
        border: '0',
        padding: '0',
        backgroundColor: 'transparent',
        color: theme.palette[iconColor ?? 'primary'].main,
        boxShadow: '0 0',
    },
}));
